import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import React, { ReactElement } from 'react';
import { Provider } from 'react-redux';
import store from '@/store';
import './global.less';
import Router from './router';

dayjs.extend(timezone);
dayjs.extend(utc);

export default function App(): ReactElement {
    return (
        <Provider store={store}>
            <Router />
        </Provider>
    );
}

